<app-ace-select
    bindLabel="displayName"
    [bindValue]="bindValueToId ? 'template_category_id' : null"
    [virtualScroll]="true"
    [appendTo]="appendTo"
    [items]="categories"
    [loading]="loading"
    [placeholder]="placeholder | messageTranslate"
    [hideSelected]="hideSelected"
    [isReadOnly]="isReadOnly"
    [multiSelect]="multiSelect"
    [closeOnSelect]="!multiSelect"
    [maxSelectedLabels]="maxSelectedLabels"
    [maxSelectedShowItemName]="!!maxSelectedShowItemName"
    [maxSelectedItemName]="maxSelectedItemName"
    [truncateLabels]="truncateLabels"
    [formControl]="control"
    (touched)="onTouched()"
    (openEvent)="onOpen()"
    (closeEvent)="onClose()"/>